export const experienceData = [
    {
        title: "Java Full Stack Developer",
        company: "HCL Tech, USA",
        date: "03/2025 - Present"
    },
    {
        title: "Java Full Stack Developer",
        company: "KPIT, India",
        date: "09/2020-11/2023"
    },

]